import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import CommonLoading from "../components/loader/CommonLoading";
import CommunityMainSection from "../components/community/MainSection";
import ContentWithCards from "../components/shared/ContentWithCards";
import { getCommunityAction, getJoinedCommunitiesAction } from "../redux/actions/communityActions";

const CommunityPosts = () => {
  const dispatch = useDispatch();
  const { communityName } = useParams();

  const { joinedCommunities, communityData, communityError } = useSelector((state) => state.community || {});
  const isMember = joinedCommunities?.some(
    ({ name }) => name === communityName
  );


  useEffect(() => {
    if (communityName && communityName !== 'undefined') {
      // Always refresh joined communities to ensure data is up-to-date
      dispatch(getJoinedCommunitiesAction());
      dispatch(getCommunityAction(communityName));
    }
  }, [dispatch, communityName]);

  if (!communityData || !joinedCommunities) {
    return (
      <ContentWithCards>
        <div className="main-section flex items-center justify-center h-screen">
          <CommonLoading />
        </div>
      </ContentWithCards>
    );
  }

  // Check if user is actually a member based on fresh backend data
  if (!isMember) {
    return (
      <ContentWithCards>
        <div className="main-section flex items-center justify-center h-screen">
          <div className="text-center">
            <h2 className="text-xl font-semibold text-gray-700 mb-2">Access Denied</h2>
            <p className="text-gray-500 mb-4">You are not a member of this community.</p>
            <a
              href={`/skills-feed/${communityName}`}
              className="bg-primary-700 hover:bg-primary-800 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
            >
              View Community Info
            </a>
          </div>
        </div>
      </ContentWithCards>
    );
  }

  if (communityError) {
    return (
      <ContentWithCards>
        <div className="main-section flex items-center justify-center h-screen">
          <div className="text-center">
            <h2 className="text-xl font-semibold text-gray-700 mb-2">Error Loading Community</h2>
            <p className="text-gray-500">{communityError}</p>
          </div>
        </div>
      </ContentWithCards>
    );
  }

  // Show the posts (since user clicked "View Posts" from My Communities)
  return (
    <ContentWithCards>
      <div className="main-section">
        <CommunityMainSection />
      </div>
    </ContentWithCards>
  );
};

export default CommunityPosts;
